import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button, Flex, Text } from 'pcln-design-system'
import { User } from 'pcln-icons'

const NoWrapFlex = styled(Flex)`
  white-space: nowrap;
`

function SignIn({ className, color, isMobile, onLoginClicked }) {
  const SIGN_IN = 'Sign In'
  return (
    <Button label={SIGN_IN} size='medium' color={color} variation='link' onClick={onLoginClicked}>
      <NoWrapFlex className={className} alignItems='center'>
        {!isMobile && <User mr={2} color={color} data-testid='user-icon' />}
        <Text color={color}>{SIGN_IN}</Text>
      </NoWrapFlex>
    </Button>
  )
}

SignIn.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  isMobile: PropTypes.bool,
  onLoginClicked: PropTypes.func,
}

export default memo(SignIn)
